// @flow
import React from "react";
import { noop } from "lodash";
import type { NullaryFn } from "@tvg/types/Functional";
import buildColor from "@fdr/static-ui/ColorPalette";
import { promo } from "@fdr/static-ui/Icons/icons";
import Icon from "@fdr/static-ui/Icons";

import { Text, PromoLink, PromoLinkExternal } from "./styled-components";

export const DefaultPromoText = {
  optedIn: "Opted-in",
  promoAvailable: "Promo Available"
};

export const PromoTextXSell = {
  optedIn: "Opted-in",
  promoAvailable: "Promo"
};

export type PromoText = {
  optedIn: string,
  promoAvailable: string
};

export type Props = {
  onClick: NullaryFn<mixed>,
  isOptedIn: boolean,
  isExternal: boolean,
  qaLabel: string,
  url: string,
  promoText: PromoText
};

const renderIcon = (isOptedIn: boolean) => (
  <Icon
    color={isOptedIn ? buildColor("white", "100") : buildColor("navy", "900")}
    icon={promo}
    size={16}
    qaLabel="promo-button-icon"
  />
);

const PromoButton = ({
  onClick,
  isOptedIn,
  qaLabel,
  url,
  isExternal,
  promoText
}: Props) => {
  const PromoLinkComponent = isExternal ? PromoLinkExternal : PromoLink;
  return (
    <PromoLinkComponent
      to={url}
      onClick={onClick}
      data-qa-label={qaLabel}
      type={isOptedIn ? "optedIn" : "promo"}
    >
      {renderIcon(isOptedIn)}
      <Text>{isOptedIn ? promoText.optedIn : promoText.promoAvailable}</Text>
    </PromoLinkComponent>
  );
};

PromoButton.defaultProps = {
  onClick: noop,
  isOptedIn: false,
  isExternal: false,
  qaLabel: "promoButton",
  url: "",
  promoText: DefaultPromoText
};

export default PromoButton;
